@if (hasBackgroundImage) {
  <section
    class="use-background-image background-image-attributes view-point-background"
    [style.background-image]="backgroundImageUrl">
    <ng-container [ngTemplateOutlet]="dashboardMarkup"></ng-container>
  </section>
} @else {
  <ng-container [ngTemplateOutlet]="dashboardMarkup"></ng-container>
}
<ng-template #dashboardMarkup>
  @if (pane.useTwelveColumnGrid) {
    <lm-twelve-column-grid #dashboardViewComponent
      [dashboardPanels]="panels"
      [fromDataView]="m_fromDataView"
      [messageRuleView]="messageRuleView"
      [displayedOnPagePanel]="true"
      (contentModified)="onContentModified($event)"
      (dashboardContentDisplayed)="onDashboardContentDisplayed()"
      (sendContextMessageEvent)="onSendContextMessageEvent($event)"
      (panelTransactionEvent)="onPanelDataUpdated($event)"
    ></lm-twelve-column-grid>
  } @else {
    <lm-dashboard-view #dashboardViewComponent
      [dashboardPanels]="panels"
      [fromDataView]="m_fromDataView"
      [columns]="columns"
      [messageRuleView]="messageRuleView"
      [displayedOnPagePanel]="true"
      [refreshAfterInit]="true"
      (contentModified)="onContentModified($event)"
      (dashboardContentDisplayed)="onDashboardContentDisplayed()"
      (sendContextMessageEvent)="onSendContextMessageEvent($event)"
      (panelTransactionEvent)="onPanelDataUpdated($event)"
    ></lm-dashboard-view>
  }
</ng-template>
